// cmp/utils/dayjs.js と同じ import 文（`import { dayjsTz as dayjs } from '~/utils/dayjs'`）で使えるようにしたモジュール。
// ロジックは utils/tool.js の parseTz（Asia/Tokyo 固定）そのもので、cmp と同じく dayjs の静的メソッド
// （isDayjs / tz / utc / min / max / extend / locale 等）を parseTz にコピーして dayjsTz として公開する。
// cmp と同一内容を保つ utils（chartTheme.js, statusChip.js 等）から使う。
// 会員アプリ内の通常の日時処理は従来どおり dayjsWapper / dayjsWapperNormal（どちらも parseTz 経由）を使う
import dayjs from 'dayjs' // プラグインは utils/tool.js の import 時に extend 済み（同じ dayjs インスタンス）
import { parseTz } from '~/utils/tool'

Object.keys(dayjs).forEach((key) => {
  if (parseTz[key] === undefined) parseTz[key] = dayjs[key]
})

export const dayjsTz = parseTz
export default dayjsTz
